import { useEffect, useRef } from 'react';

/**
 * Adds "is-pinned" class to element that uses returned ref
 */
export function useStickyPinned<TElement extends Element>() {
  const ref = useRef<TElement>(null);

  useEffect(() => {
    const refValue = ref.current;
    if (typeof IntersectionObserver === 'undefined' || !refValue) return;

    // eslint-disable-next-line compat/compat
    const observer = new IntersectionObserver(
      ([element]) => {
        if (!element) return;

        element.target.classList.toggle(
          'is-pinned',
          element.intersectionRatio !== 0 && element.intersectionRatio < 1,
        );
      },
      {
        threshold: [1],
      },
    );

    observer.observe(refValue);

    return () => {
      observer.disconnect();
      observer.unobserve(refValue);
    };
  }, [ref]);

  return ref;
}
